import { render } from "./PaymentTerms.vue?vue&type=template&id=43495ae8&scoped=true"
import script from "./PaymentTerms.vue?vue&type=script&lang=js"
export * from "./PaymentTerms.vue?vue&type=script&lang=js"

import "./PaymentTerms.vue?vue&type=style&index=0&id=43495ae8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43495ae8"]])

export default __exports__